import { Component } from 'react';
import { css } from '@emotion/react';

import TitleTextGroup from './common/molecules/TitleTextGroup';
import TeaserGridMolecule, {
  formatEventArrayAsTeaserItemArray,
} from './common/molecules/TeaserGrid';

import * as InternalPropTypes from '../constants/internal-types';
import ContentOuterBound from './common/atoms/ContentOuterBound';
import ContentSpacer from './common/atoms/ContentSpacer';
import {
  TypeBackgroundColorTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';
import { getLowerSEOWeight } from '../utils/SEOWeight';

const styles = css({
  '& .title': {
    marginTop: '25px',
    marginBottom: '35px',
  },
});

type EventPastGridProps = {
  events?: InternalPropTypes.Event[];
  backgroundColor?: TypeBackgroundColorTypes;
  mainHeader?: InternalPropTypes.RichText;
  showNumbering?: boolean;
  seoWeight?: TypeSEOWeightTypes;
};

class EventPastGrid extends Component<EventPastGridProps> {
  static defaultProps = {
    events: [],
    backgroundColor: null,
    mainHeader: '',
    showNumbering: false,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const { events, backgroundColor, mainHeader, showNumbering, seoWeight } =
      this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    const lowerSEOWeight = getLowerSEOWeight(seoWeight);
    return (
      <div css={[styles, addStyle]} className="event-past-component">
        <ContentOuterBound>
          <ContentSpacer>
            <TitleTextGroup titleText={mainHeader} seoWeight={seoWeight} />
            <div className="grid">
              <TeaserGridMolecule
                items={formatEventArrayAsTeaserItemArray(events)}
                showNumbering={showNumbering}
                seoWeight={lowerSEOWeight}
              />
            </div>
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default EventPastGrid;
